<template>
	<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-width="0" status-icon>
		<el-form-item prop="username">
			<el-input
				v-model="loginForm.username"
				auto-complete="off"
				placeholder="请输入用户名"
				prefix-icon="el-icon-user"
				size="small"
				@keyup.enter.native="handleLogin">
				<!-- <i slot="prefix" class="icon-yonghuming" /> -->
			</el-input>
		</el-form-item>
		<el-form-item prop="password">
			<el-input
				v-model="loginForm.password"
				:type="passwordType"
				auto-complete="off"
				placeholder="请输入密码"
				prefix-icon="el-icon-lock"
				size="small"
				@keyup.enter.native="handleLogin">
				<i slot="suffix" class="el-icon-view el-input__icon" @click="showPassword" />
				<!-- <i slot="prefix" class="icon-mima"></i> -->
			</el-input>
		</el-form-item>
		<!-- 记住账号密码-->
		<el-form-item prop="remember">
			<el-checkbox v-model="remember">记住账号密码</el-checkbox>
		</el-form-item>
		<el-form-item>
			<el-button
				:loading="isLoginLoading"
				class="login-submit"
				size="small"
				type="primary"
				@click.native.prevent="handleLogin">
				登录
			</el-button>
		</el-form-item>

		<el-form-item prop="code">
			<Verify
				ref="verify"
				:captchaType="'clickWord'"
				:imgSize="{width: '330px', height: '155px'}"
				:mode="'pop'"
				@success="verifySuccess" />
		</el-form-item>
	</el-form>
</template>

<script>
import {mapGetters} from 'vuex'
import Verify from '@/components/verifition/Verify'

export default {
	name: 'Userlogin',
	components: {
		Verify,
	},
	data() {
		return {
			//失效时间7 天
			failureTime: 7 * 24 * 60 * 60 * 1000,
			remember: false,
			isLoginLoading: false,
			socialForm: {
				code: '',
				state: '',
			},
			loginForm: {
				username: '',
				password: '',
				code: '',
				randomStr: 'blockPuzzle',
			},
			checked: false,
			code: {
				src: undefined,
				len: 4,
			},
			loginRules: {
				username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
				password: [
					{required: true, message: '请输入密码', trigger: 'blur'},
					{min: 6, message: '密码长度最少为8位', trigger: 'blur'},
				],
			},
			passwordType: 'password',
		}
	},
	computed: {
		...mapGetters(['tagWel']),
	},
	created() {
		//判断是否记住密码
		if (localStorage.getItem('ieLoginForm')) {
			// 判断有没有超过有效时间
			let time = localStorage.getItem('ieLoginFormTime')
			if (time && new Date().getTime() > Number(time)) {
				localStorage.removeItem('ieLoginForm')
				localStorage.removeItem('ieLoginFormTime')
			} else {
				let loginForm = JSON.parse(localStorage.getItem('ieLoginForm'))
				this.loginForm.username = loginForm.username
				//密码解密 window.btoa('asb32'+this.loginForm.password+'hxd3ds6781scc'),
				let password = window.atob(loginForm.password)
				password = password.substring(5, password.length - 13)
				this.loginForm.password = password
				this.remember = loginForm.remember
			}
		}
	},
	methods: {
		//设置账号密码
		setLoginData(name, code) {
			Object.assign(this.loginForm, {username: name, password: code, isLocal: false})
			//直接登录
			this.handleLogin()
		},
		showPassword() {
			this.passwordType == '' ? (this.passwordType = 'password') : (this.passwordType = '')
		},
		handleLogin() {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					//显示图片
					this.$refs.verify.show()
				}
			})
		},
		verifySuccess(params) {
			this.isLoginLoading = true
			this.loginForm.code = params.captchaVerification
			// Modified by Li Yong on 2021/09/03
			// this.$store.dispatch("LoginByUsername", this.loginForm).then(() => {
			//   this.$router.push({ path: this.tagWel.value });
			// });
			this.$store
				.dispatch('LoginByUsername', this.loginForm)
				.then((res) => {
					//判断是否记住密码  将用户名密码 以及是否记住账号密码放入缓存 如果没有勾选择清理缓存
					if (this.remember) {
						let ieLoginFormTime = localStorage.getItem('ieLoginFormTime')
						if (!ieLoginFormTime) {
							// 有效期时间 10 分钟
							let time = new Date().getTime()
							localStorage.setItem('ieLoginFormTime', time + this.failureTime)
						}

						localStorage.setItem(
							'ieLoginForm',
							JSON.stringify({
								username: this.loginForm.username,
								//密码加密 添加简单混淆
								password: window.btoa('asb32' + this.loginForm.password + 'hxd3ds6781scc'),
								remember: this.remember,
							}),
						)
					} else {
						localStorage.removeItem('ieLoginForm')
					}

					this.$router.push({path: this.tagWel.value})
					// if (!res || res === 0) {
					//   this.$router.push({ path: this.tagWel.value })
					// } else {
					//   this.$parent.needResetPassword = true
					// }
				})
				.catch(() => {})
				.finally(() => {
					this.isLoginLoading = false
				})
			//
		},
	},
}
</script>

<style></style>
